<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_dptch_rcrds"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >DISPATCH RECORDS/CALLS FOR SERVICE/911 CALL REQUESTS
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-2">
        <!-- jlm 4/1/2025 Mina Almario -->
        <a href="https://reno.govqa.us/WEBAPP/_rs/" target="_blank"
          >CITY OF RENO PUBLIC RECORDS PORTAL</a
        >
        <span class="black--text">
          For; Dispatch Records, Calls for Service, 911 Call requests must be
          submitted online by clicking on the above link:
        </span>
      </div>
      <div class="mt-1 black--text">
        Create an account and
        <span class="text-decoration-underline font-italic"
          >choose ‘Category’ 3- General Records</span
        >
      </div>
      <div class="mt-1" style="color: black">
        For questions, please contact:
        <a href="tel:775-334-2121">775-334-2121</a>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_dptch_rcrds",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
